<template>
    <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: stretch">
        <div style="flex-grow: 0; height: 60px; padding: 10px;">
            <div style="width: 500px">
                <search-bar
                        reactivity="input"
                        v-model="search" placeholder="검색"></search-bar>
            </div>
        </div>
        <div style="flex-grow: 1; height: calc(100% - 60px);">
            <vue-data-table
                    ref="dataTable"
                    v-model="selected"
                    :headers="headers"
                    :items="items"
                    :search="search"
                    item-key="countryCode"
                    show-select
            ></vue-data-table>
        </div>
    </div>
</template>

<script>
    import VueDataTable from "@/assets/plugins/vue-data-table/VueDataTable";
    import {PATH} from "@/constants";
    import SearchBar from "@/components/input/SearchBar";
    import {dateHelper} from "@/assets/plugins/mps-common/time/date-helper";

    export default {
        name: "MonitoringAgentCycleByCountry",
        components: {SearchBar, VueDataTable},
        data() {
            return {
                search: "",
                selected: [],
                items: [],
                headers: [
                    {
                        text: "국가",
                        value: "countryName",
                        width: 300,
                    },
                    {
                        text: "주기 설정",
                        value: "codeValue",
                        width: 500,
                    },
                    {
                        text: "변경일",
                        value: "uptDatetime",
                        read: (v, item) => dateHelper.formatDateTime(v),
                        width: 200,
                    },
                    {
                        text: "등록자",
                        value: "register",
                        width: 200,
                    },
                ],
                searchOptions: {},
            }
        },
        computed: {
            disableDeploy() {
                return this.$isEmpty(this.selected);
            },
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                const res = await this.$request(PATH.MONITORING.AGENT_CYCLE_BY_COUNTRY)
                    .setObject({
                        ...this.searchOptions,
                    })
                    .catch()
                    .enqueue();
                this.items = res.data;
            },
        },
    }
</script>

<style scoped>

</style>